export function inViewPort(element, callback, options, delay) {
    if (options === void 0) { options = { rootMargin: "50px", threshold: 0.25 }; }
    if (delay === void 0) { delay = 0; }
    if (!element || !callback)
        return false;
    var inViewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var target_1 = entry.target;
                if (delay > 0) {
                    setTimeout(function () {
                        callback(target_1);
                        inViewObserver.unobserve(target_1);
                    }, delay);
                    return;
                }
                callback(target_1);
                inViewObserver.unobserve(target_1);
            }
        });
    }, options);
    inViewObserver.observe(element);
    return element;
}
export var isInViewport = function (element) {
    var rect = element.getBoundingClientRect();
    var windowHeight = "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    var top = rect.top + windowHeight <= windowHeight;
    var bottom = rect.bottom >= windowHeight;
    return top && bottom;
};
